import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  Alert,
  LinearProgress,
} from '@mui/material';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import BarChart from './Charts/BarChart';
import LineChart from './Charts/LineChart';

const ChartCard = ({ title, children }) => (
  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
    <CardHeader title={title} titleTypographyProps={{ variant: 'subtitle1', fontWeight: 700 }} sx={{ pb: 0 }} />
    <CardContent>{children}</CardContent>
  </Card>
);

const AdminAnalytics = ({ analytics, analyticsLoading, analyticsError }) => {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: '0px 16px 45px rgba(15, 23, 42, 0.12)' }}>
      <CardHeader
        title="Analytics"
        subheader="Platform-wide event tracking and usage insights"
        titleTypographyProps={{ variant: 'h5', fontWeight: 700 }}
      />
      {analyticsLoading && <LinearProgress color="primary" />}
      <CardContent>
        {analyticsError && <Alert severity="error" sx={{ mb: 2 }}>{analyticsError}</Alert>}
        {analyticsLoading ? null : (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <ChartCard title="Events by Type">
                <BarChart data={analytics?.eventsByType} labelKey="type" valueKey="count" />
              </ChartCard>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <ChartCard title="Daily Events">
                <LineChart data={analytics?.dailyEvents} labelKey="date" valueKey="count" />
              </ChartCard>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <ChartCard title="Top Users">
                <BarChart data={analytics?.topUsers} labelKey="username" valueKey="count" />
              </ChartCard>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminAnalytics;
